export enum MissingValueType {
    SqFt,
    PurchasePrice,
    RentalRate,
}
